<template>
    <v-container >
      <v-card pa-2 >
        <div align="left" class="pa-2">

            Smooth Talkr is a tool for creating engaging human-computer interactions. This is an ealy Beta version, and we humbly ask for your feedback, patience, ideas, and direction.  Please send them to <a href="mailto:info@talkrapp.com">info@talkrapp.com</a>
            <br><br>
            <h3>Technologies We Use:</h3>
            <ul>
              <br><li><h4>Talkr</h4> is an <a href="https://talkrapp.com"> iOS app </a> that lets you create movies from talking pictures.  It can export GIF files that are used to create many of the realistic avatars on this site.</li>
              <br><li><h4>Smooth Script</h4> Is a free and open source scripting language on <a href="https://github.com/talkr-app/smooth-script">github</a></li>
              <br><li><h4>Looping Avatars</h4> A simple, yet powerful web-based avatar format that loops through the frames of an APNG file.  For more information see <a href="https://github.com/talkr-app/talkr-apng">here.</a></li>
            </ul>
            <br><br>
            <h3>Additional Help</h3>
            <br><br>Please refer to the <a href='#/play/VyB4gYHkoVnSX8VG6w1h'>sample scenes</a> for more detailed and up-to-date info and examples.
        </div>
      </v-card>
    </v-container>
</template>
<script>
export default {
  props: {},
  data () {
    return {
    }
  },
  mounted: function () {
  },
  methods: {
    onClearCash: function () {

    }
  }
}
</script>
<style>
H2 {display: inline;}
H3 {display: inline;}
H4 {display: inline;}
H5 {display: inline;}
H6 {display: inline;}
</style>



// WEBPACK FOOTER //
// src/components/About.vue